import React from "react";
import styled from "styled-components";
import SwitchComponent from "./card-filters/SwitchComponent";
import ResetBtn from "./card-filters/ResetBtn";
import FilterBtns from "./card-filters/FilterButtons";

const FilterWrapper = styled.div`
  width: 100%;
  height: 32px;
  margin: 32px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

type FilterProps = {
  width: string;
  height: string;
};

const StyledFilterWrapper = styled.div<FilterProps>`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export default function FilterCards() {
  return (
    <FilterWrapper>
      <StyledFilterWrapper width={"310px"} height={"30px"}>
        <FilterBtns />
        <ResetBtn />
      </StyledFilterWrapper>

      <SwitchComponent />
    </FilterWrapper>
  );
}
